import React from "react";
import PropTypes from "prop-types";
import { useTrans } from "../../hooks";
import { CatalogHeader } from "./CatalogHeader";
import { PaidStoriesCatalog } from "./catalogs/PaidStoriesCatalog";
import PremiumPicksCatalog from "./catalogs/PremiumPicksCatalog";

function Catalog({ catalog, isMobile }) {
  const { trans } = useTrans();

  switch (catalog) {
    case "paidstories":
    case "wattpadoriginals":
      return (
        <div className="catalog-container">
          <CatalogHeader
            title={
              catalog === "paidstories"
                ? trans("Paid Stories")
                : trans("Wattpad Originals")
            }
            catalog={catalog}
            isMobile={isMobile}
          />
          <PaidStoriesCatalog catalog={catalog} />
        </div>
      );
    case "premiumpicks":
      return <PremiumPicksCatalog />;
  }

  return null;
}

Catalog.propTypes = {
  catalog: PropTypes.string.isRequired,
  isMobile: PropTypes.bool.isRequired
};

export { Catalog };
